import { render, staticRenderFns } from "./DocAcaoComentar.vue?vue&type=template&id=59dec8f5&scoped=true&lang=pug&"
import script from "./DocAcaoComentar.vue?vue&type=script&lang=js&"
export * from "./DocAcaoComentar.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoComentar.vue?vue&type=style&index=0&id=59dec8f5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dec8f5",
  null
  
)

export default component.exports